import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import { Grid, useTheme } from "@mui/material";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AuthService } from "../../../services";
import { DDLDataTable } from "../../DDLDataTable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { IUsers } from "../../../models";
import { MenuHeadsService } from "../../../services/RoleManagementServices/MenuHeadsService";
import { UserSetupValidationSchema } from "./validator";
import { UsersInfoSetupFieldsPanel } from "./Panels/UsersInfoSetupFieldsPanel";
import { UsersService } from "../../../services/RoleManagementServices/UsersService";
import { UsersSetupToolbar } from "./UsersSetupToolbar";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../store/actions";
import { useNavigateToLogout } from "../../../common/Common";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "../EmployeeAssignemnt/SingleColumnLayout";




export interface IUserssSetup { }
const USERS_RECORD_DATA_QUERY_KEY = "users-single-data-record";
const USERS_LIST_DATA_QUERY_KEY = "users-list";

const useGetData = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [USERS_RECORD_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: () => {
			return UsersService.getById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useUser = (
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [USERS_LIST_DATA_QUERY_KEY, params],
		queryFn: (data) => {

			return UsersService.getUser(
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});
export const UsersSetup: React.FC<IUserssSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientStoreId = useSelector((state: IAppState) => state.client.id);
	const userIdStore = useSelector((state: IAppState) => state.user.profile.userId);
	const navigateToLogout = useNavigateToLogout();
	const [openDialog, setDialogOpen] = useState(false);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [userId, setUserId] = useState<number | string>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "userName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "userName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useUser(
		queryParams,
		navigateToLogout
	);

	const userList: any | null = data;

	const { isPending: isSubmitting, mutate: submitUserFormFields } =
		useMutation({
			mutationFn: AuthService.registerUser,
			onSuccess: (res: IServerError | IResponse | any) => {

				if (res.message === "User register successfully.") {

					setSnackbarData({
						open: true,
						message: "Your registration is now complete. Your account activation link has been sent to your email address.",
						severity: "success",
					});

					// let path = `/role-management/users/${res.id}`;
					// navigate(path);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [USERS_LIST_DATA_QUERY_KEY],
						}),
						// queryClient.invalidateQueries({
						// 	queryKey: [USERS_RECORD_DATA_QUERY_KEY],
						// }),
					]);
				} else {

					setSnackbarData({
						open: true,
						message: res?.message ? res.message : "Somethingwent wrong!",
						severity: res.status === false ? "error" : res.success === false ? "error" : "success",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!!!!",
					severity: "error",
				});
			},
		});

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		editRecordId,
		navigateToLogout
	);

	const upadtedUserListItems = useMemo(() => {
		return (
			userList &&
			userList.items &&
			userList?.items.map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/role-management/users/${item.id}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => setEditRecordId(item.id)}
					>
						{item.firstName}
					</Link>
				),
			}))
		);
	}, [userList]);


	const DEFAULT_VALUES = {
		code: undefined,
		userName: undefined,
		notes: undefined,

	};

	const formMethods = useForm<any>({
		resolver: yupResolver(UserSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const onSubmit = (values: any) => {

		let payload = {
			id: id && id,
			navigateToLogout: navigateToLogout,
			firstName: values.firstName,
			lastName: values.lastName,
			email: values.email,
			adminAccountantUser: false,
			timezone: values.timezone,
			// isSuperStatus: 500,
			// primaryUser:false,
			// ipAddress: values.ipAddress,
			// createdByExternalId:userIdStore
		};
		submitUserFormFields(payload);
	};

	useEffect(() => {
		if (id && selectedDataRecord) {

			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
			});
		}
	}, [id, selectedDataRecord]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteUserById } = useMutation({
		mutationFn: UsersService.delUser,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the User fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/users`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [USERS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteUserField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				userId: userId,
				navigateToLogout: navigateToLogout,
			};
			deleteUserById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setUserId(selectedDataRecord.id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setUserId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveUserById } = useMutation({
		mutationFn: UsersService.archiveUser,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the User fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/role-management/users`;
			navigate(path);
			return queryClient.invalidateQueries({
				queryKey: [USERS_LIST_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveUserField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				userId: userId,
				navigateToLogout: navigateToLogout,
			};
			archiveUserById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setUserId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		let path = `/role-management/users`;
		navigate(path);
	};

	const expandedLabels = ["Role Management"];
	const expandedLabelsForAdmin = ["User Management"];
	const expandedUserSetupItem = "Users"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientStoreId && clientStoreId !== "") {
				let isExpanded = expandedLabelsForAdmin.includes(item.label);
				if (
					parentLabel === "Users" &&
					item.label === expandedUserSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedUserSetupItem && "/role-management/users",
				};
				return enhancedItem;
			} else {
				let isExpanded = expandedLabels.includes(item.label);
				if (
					parentLabel === "Users" &&
					item.label === expandedUserSetupItem
				) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedUserSetupItem && "/role-management/users",
				};
				return enhancedItem;
			}
		});
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const onRowEditClicked = useCallback((params: IUsers | any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/role-management/users/${params.value}`;
		navigate(path);
	}, []);

	return (
		<Grid
		// sx={{
		// 	pb: "5rem",
		// 	"& .MuiAppBar-root": {
		// 		zIndex: 2,
		// 		top: subMenuVisibility ? "154px" : "112px",
		// 	},
		// }}
		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingById || isDeleting || isArchive}
				testId="user Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteUserField}
				cancelActionHandler={onCloseHandler}
				testId="user-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 3.5, lg: 3.5, xl: 3.5 }}>
							<SingleColumnLayout
								children={
									<StandardPanel
										title="User Setup"
										testId={`user - setup`}
										// leftSpacing={1}
										// rightSpacing={1}
										showTitle={false}
										variant="outlined"
										topPadding={2}
									>
										<UsersInfoSetupFieldsPanel formMethods={formMethods} id={id && id} />
									</StandardPanel>
								}
								toolbar={
									<UsersSetupToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id}
									/>
								}
								showFullDiaplay={true}
								toolbarPosition="bottom"
								testId="form-layout"
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 4, lg: 4, xl: 4 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 4.5, lg: 4.5, xl: 4.5 }}
							sx={{ marginTop: "16px" }}
						>
							<DDLDataTable
								rows={
									userList && upadtedUserListItems
										? upadtedUserListItems
										: []
								}
								columns={[
									{ field: "firstName", headerName: "First Name" },
									{ field: "lastName", headerName: "Last Name" },
									{ field: "email", headerName: "Email" },
									// { field: "phone", headerName: "Phone" },
									// { field: "status", headerName: "Status" }
								]}
								showHeaderColumns={true}
								showArchiveIcon={false}
								onRowEditClicked={onRowEditClicked}
								onRowDeleteClicked={onRowDeleteClicked}
								// onRowArchiveClicked={onArchiveClicked}
								isLoading={isPending}
								totalRecords={
									userList && userList.total
										? userList.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								selectedId={selectedDataRecord && id && selectedDataRecord.id}
							/>
						</Grid>
						<Grid size={{ xs: 0, sm: 0, md: 0, lg: 1, xl: 1 }}></Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveUserField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"user-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
